/**
 * 通用的全局过滤器
 */

/**
 * 处理金额价格
 * @param money
 * @returns {string}
 */
export const currency = money => {
  if (money || (money === 0)) {
    return `￥${money.toFixed(2)}`;
  }
  return '￥0';
};



// WEBPACK FOOTER //
// ./src/filters/common.js